import script from "./mobileSystemManage.vue?vue&type=script&setup=true&lang=js"
export * from "./mobileSystemManage.vue?vue&type=script&setup=true&lang=js"

import "./mobileSystemManage.vue?vue&type=style&index=0&id=543049e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-543049e2"]])

export default __exports__